import AskQuestionForm from "../components/chat/AskQuestionForm";
import AskQuestionFormHeader from "../components/chat/AskQuestionFormHeader";
import ChatView from "../components/chat/ChatView";
import ChatViewHeader from "../components/chat/ChatViewHeader";
import ChatListView from "../components/chat/ChatListView";
import ChatListViewHeader from "../components/chat/ChatListViewHeader";
import Main from "../components/chat/Main";
import MaximizedView from "../components/chat/MaximizedView";
import MinimizedViewContainer from "../components/chat/MinimizedViewContainer";

export default {
    component: Main,
    childRoutes: [
        {
            path: "minimized",
            component: MinimizedViewContainer,
            childRoutes: [
                {
                    path: "*",
                    onEnter: (nextState, replaceState) => {
                        console.warn(`${nextState.location.pathname} not found. Going to /minimized instead`); // eslint-disable-line no-console
                        replaceState(null, "minimized");
                    },
                },
            ],
        },
        {
            component: MaximizedView,
            childRoutes: [
                {
                    path: "ask",
                    components: {
                        header: AskQuestionFormHeader,
                        main: AskQuestionForm,
                    },
                },
                {
                    path: "list",
                    components: {
                        header: ChatListViewHeader,
                        main: ChatListView,
                    },
                },
                {
                    path: "question/:questionUuid",
                    components: {
                        header: ChatViewHeader,
                        main: ChatView,
                    },
                },
                {
                    path: "*",
                    onEnter: (nextState, replaceState) => {
                        console.warn(`${nextState.location.pathname} not found. Going to /minimized instead`); // eslint-disable-line no-console
                        replaceState(null, "/minimized");
                    },
                },
            ],
        },
    ],
};
